import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Joverride(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
  <title>Java overriding tutorial For Beginners</title>
<meta name="description" content="Java tutorial for beginners.Method overriding in java is the example of Run time polymorphism and this is also known as a dynamic polymorphism" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Dynamic Polymorphism,Polymorphism,java overriding,java override equals,java overriding vs overloading,java override annotation,overloading and overriding in java,java override hashcode,java override class,java overriding rules" />
<link rel="canonical" href="https://www.codeexampler.com/java-overriding" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Overriding in Java
</h1>
<div className="first">
        <a href="/java-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">Method overriding in java is the example of Run time polymorphism and this is also known as a <span className="bold"> Dynamic polymorphism</span>
</p>

<h2 className="mt-4 mh2">Rules of method overriding:
</h2>
<h3 className="mt-4 mh3">1, If you call two java override method so both methods place inside different classes<br/>
2, Two or multiple method names are same<br/>
3, Two or multiple method  argument are same <br/>
</h3>
<h4 className="mt-4">A, Sequence of argument<br/>
B, Numbers of argument<br/>
C, Type of argument<br/>
</h4>
<h3 className="mt-4 mh3">4,Inheritance(IS-A) relationship
</h3>



<h2 className="headings">Q-Write Program no of argument example?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over </span>
      <span className="qwerty-1">()</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"1 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&#125; </span>
      {"\n"}  {"\n"}

      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override2</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over </span>
      <span className="qwerty-1">()</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"2 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}{"\n"}


        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"} 

      <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override1</span>
      <span className="qwerty-8"> o </span>
      <span className="qwerty-8">= </span>
      <span className="qwerty-10">new</span>
      <span className="qwerty-4"> override1</span>
      <span className="qwerty-1">(); </span>
      {"\n"} 
      <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
      {"\n"} 

      <span className="qwerty-3">&nbsp;&#125; </span>
        {"\n"}

    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code >
      {"\n"}
      <span className="qwerty-9">&nbsp; 1 over</span>
      {"\n"}
        </code>{"\n"}
        </pre>
  </div>
</div>




<h2 className="headings">Q-Write Program No of argument example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over </span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"1 over"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&#125; </span>
              {"\n"}  {"\n"}
        
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override2</span>
              <span className="qwerty-8"> extends</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over </span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"2 over"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}{"\n"}
        
        
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"} 
        
              <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override2</span>
              <span className="qwerty-8"> o </span>
              <span className="qwerty-8">= </span>
              <span className="qwerty-10">new</span>
              <span className="qwerty-4"> override1</span>
              <span className="qwerty-1">(); </span>
              {"\n"} 
              <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
              {"\n"} 
        
        
        
        
        
              <span className="qwerty-3">&nbsp;&#125; </span>
                {"\n"}
        
        
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code >
              {"\n"}
              <span className="qwerty-9">&nbsp; 2 over</span>
              {"\n"}
                </code>{"\n"}
                </pre>
          </div>
        </div>




<h2 className="headings">Q-Write Program A type of arguments?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a </span>
      <span className="qwerty-1">)</span>
      {"\n"} 
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"1 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&#125; </span>
      {"\n"}  {"\n"}

      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override2</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a </span>
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"2 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}{"\n"}


        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"} 

      <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override2</span>
      <span className="qwerty-8"> o </span>
      <span className="qwerty-8">= </span>
      <span className="qwerty-10">new</span>
      <span className="qwerty-4"> override2</span>
      <span className="qwerty-1">(); </span>
      {"\n"} 
      <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-8">50</span>
        <span className="qwerty-1">)</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
      {"\n"} 

      <span className="qwerty-3">&nbsp;&#125; </span>
        {"\n"}

    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code >
      {"\n"}
      <span className="qwerty-9">&nbsp; 2 over</span>
      {"\n"}
        </code>{"\n"}
        </pre>
  </div>
</div>





<h2 className="headings">Q-Write Program A type of arguments?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a </span>
      <span className="qwerty-1">)</span>
      {"\n"} 
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"1 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&#125; </span>
      {"\n"}  {"\n"}

      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> override2</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> override1</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;void </span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a </span>
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"2 over"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
      {"\n"}{"\n"}


        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"} 

      <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override1</span>
      <span className="qwerty-8"> o </span>
      <span className="qwerty-8">= </span>
      <span className="qwerty-10">new</span>
      <span className="qwerty-4"> override1</span>
      <span className="qwerty-1">(); </span>
      {"\n"} 
      <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-8">over</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-8">50</span>
        <span className="qwerty-1">)</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
      {"\n"} 





      <span className="qwerty-3">&nbsp;&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code >
      {"\n"}
      <span className="qwerty-9">&nbsp; 1 over</span>
      {"\n"}
        </code>{"\n"}
        </pre>
  </div>
</div>



<h2 className="headings">Q-Write Program the sequence of arguments?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
                <span className="qwerty-10">int </span>
              <span className="qwerty-4">x </span>
              <span className="qwerty-8"> , </span>
              <span className="qwerty-10">String </span>
              <span className="qwerty-4">y </span>
              <span className="qwerty-1">)</span>
              {"\n"} 
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"override int String"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&#125; </span>
              {"\n"}  {"\n"}
        
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override2</span>
              <span className="qwerty-8"> extends</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">int </span>
              <span className="qwerty-4">x </span>
              <span className="qwerty-8"> , </span>
              <span className="qwerty-10">String </span>
              <span className="qwerty-4">y </span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"override string int"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}{"\n"}
        
        
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"} 
        
              <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override1</span>
              <span className="qwerty-8"> o </span>
              <span className="qwerty-8">= </span>
              <span className="qwerty-10">new</span>
              <span className="qwerty-4"> override1</span>
              <span className="qwerty-1">(); </span>
              {"\n"} 
              <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
                <span className="qwerty-8">50</span>
                <span className="qwerty-8"> , </span>
                <span className="qwerty-8">"Ram"</span>
                <span className="qwerty-1">)</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
              {"\n"} 
        
        
        
        
        
              <span className="qwerty-3">&nbsp;&#125; </span>
                {"\n"}
        
        
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code >
              {"\n"}
              <span className="qwerty-9">&nbsp; override int String</span>
              {"\n"}
                </code>{"\n"}
                </pre>
          </div>
        </div>



<h2 className="headings">Q-Write Program the sequence of arguments?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
                <span className="qwerty-10">int </span>
              <span className="qwerty-4">x </span>
              <span className="qwerty-8"> , </span>
              <span className="qwerty-10">String </span>
              <span className="qwerty-4">y </span>
              <span className="qwerty-1">)</span>
              {"\n"} 
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"override int String"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&#125; </span>
              {"\n"}  {"\n"}
        
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> override2</span>
              <span className="qwerty-8"> extends</span>
              <span className="qwerty-4"> override1</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp;void </span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">int </span>
              <span className="qwerty-4">x </span>
              <span className="qwerty-8"> , </span>
              <span className="qwerty-10">String </span>
              <span className="qwerty-4">y </span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"override string int"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp; &#125; </span>
              {"\n"}{"\n"}
        
        
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
              {"\n"} 
        
              <span className="qwerty-4">&nbsp; &nbsp;&nbsp; &nbsp;override2</span>
              <span className="qwerty-8"> o </span>
              <span className="qwerty-8">= </span>
              <span className="qwerty-10">new</span>
              <span className="qwerty-4"> override2</span>
              <span className="qwerty-1">(); </span>
              {"\n"} 
              <span className="qwerty-8">&nbsp; &nbsp;&nbsp;&nbsp; o</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-8">over</span>
              <span className="qwerty-1">(</span>
                <span className="qwerty-8">40</span>
                <span className="qwerty-8"> , </span>
                <span className="qwerty-8">"Lakshmana"</span>
                <span className="qwerty-1">)</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
              {"\n"} 
        
        
        
        
        
              <span className="qwerty-3">&nbsp;&#125; </span>
                {"\n"}
        </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code >
              {"\n"}
              <span className="qwerty-9">&nbsp; override string int</span>
              {"\n"}
                </code>{"\n"}
                </pre>
          </div>
        </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">

       
       
        <a href="/java-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Joverride;